import { useContext, useEffect, useState } from 'react';
import { PermissionContext } from 'components/Global/AuthLayout';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'components/Global';

interface PermissionGuardProps {
	permission?: string;
	isAdmin?: boolean;
	children: React.ReactNode;
}

const PermissionGuard = ({
	permission = '',
	children,
	isAdmin = false,
}: PermissionGuardProps) => {
	const context = useContext(PermissionContext);
	const navigate = useNavigate();

	const [checked, setChecked] = useState(false);
	const [canAccess, setCanAccess] = useState(false);

	// Wait until permissions are loaded
	useEffect(() => {
		const { allowedPermissions } = context;

		// Don't do anything until permissions are loaded
		if (!allowedPermissions || allowedPermissions.length === 0) {
			setChecked(false);	
			return;
		}	
		 if (isAdmin) {
			setCanAccess(true);
			setChecked(true);
			return;
		}
		// Check permission for non-admins
		 if (permission) {
			const hasPermission = allowedPermissions.includes(permission);
			setCanAccess(hasPermission);
			setChecked(true);
			if (!hasPermission) {
				navigate('/');
			}
		} else {
			// If no specific permission is required
			setCanAccess(true);
			setChecked(true);
		}
	}, [context.allowedPermissions, isAdmin, permission, navigate]);

	if (!checked) {
		// Still loading permissions or checking access
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '85vh',
				}}
			>
				<Loader />
			</div>
		);
	}
	return <>{canAccess && children}</>;
};

export default PermissionGuard;
